/* eslint-disable import/no-anonymous-default-export */
import axios, { AxiosError } from "axios"
import useApi, { ActionResult, Api, Model, Query } from "../common/hooks/useApi"
import { Infraccion } from "../infracciones/hooks/useInfraccionesAPI"

export interface InfraccionesInfractor extends Model {
    InfractorNombreCompleto:string
    InfractorNombre:string
    InfractorApellido:string
    InfractorCuitCuil:string
    InfractorTipo: ("OTRO" | "EMPRESA" | "MASCULINO" | "FEMENINO")
    CantidadInfracciones:number
    TelefonosFijo: string
    TelefonosCelulares: string
    Emails: string
    InfraccionId: number
    InfractorId: number
    Estado: string
}

export interface InfraccionesInfractorTableProps {
    list: (query: Query) => Promise<ActionResult<Infraccion[]>>
    onInfraccionesSelectionChanged?: (items: Infraccion[]) => any
    title: string
}

const module = "InfraccionesInfractor";
export default () => {
    const api = useApi({ module });
    const apiInfracciones = useApi({ module: "Infraccion" });
    return {
        list: (query: Query) => api.list!<InfraccionesInfractor>(query),
        listImpagas: (query: Query) => api.list!<InfraccionesInfractor>(query, undefined, "Impagas()"),
        listInfraccionesCuitCuil: (query: Query, cuitCuil:string)=> api.list!<Infraccion>(query, [`cuitCuil=${cuitCuil}`], "InfraccionesCuitCuil()"),
        listInfraccionesCuitCuilEnviadas: (query: Query, cuitCuil:string)=> api.list!<Infraccion>(query, [`cuitCuil=${cuitCuil}`], "InfraccionesCuitCuilEnviadas()")
    };
}